import { DistributionSendFromApi } from '../../../api/distributions/model/distribution-api.model';
import { BaseModel } from '../../../Common/Basic/models/base.model';

export class DistributionSendFrom extends BaseModel<DistributionSendFrom, DistributionSendFromApi> {

    id: number;
    connectionId: number;
    grantId: number;
    connectionEmail: string;

    // F/E only
    connectionName?: string;
    requiresReAuthentication: boolean;

    constructor(apiModel?: DistributionSendFromApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructDefault() {
        this.requiresReAuthentication = false;
    }

    constructFromApiModel(apiModel: DistributionSendFromApi) {
        this.id = apiModel.id;
        this.connectionId = apiModel.connectionId;
        this.grantId = apiModel.grantId;
        this.connectionEmail = apiModel.connectionEmail;
    }

    toApiModel() {
        return {
            id: this.id,
            connectionId: this.connectionId,
            grantId: this.grantId,
            connectionEmail: this.connectionEmail
        };
    }

    clone(): DistributionSendFrom {
        const clone = new DistributionSendFrom(this.toApiModel());
        clone.connectionName = this.connectionName;
        clone.requiresReAuthentication = this.requiresReAuthentication;

        return clone;
    }

    equals(other?: DistributionSendFrom): boolean {
        if (!other) {
            return false;
        }

        if (this.connectionId !== other.connectionId) {
            return false;
        }

        if (this.grantId !== other.grantId) {
            return false;
        }

        if (this.connectionEmail !== other.connectionEmail) {
            return false;
        }

        if (this.connectionName !== other.connectionName) {
            return false;
        }

        if (this.requiresReAuthentication !== other.requiresReAuthentication) {
            return false;
        }

        return true;
    }
}
